import React, { useMemo } from "react";
import { Tag } from "antd";
import { dateStringToStandardFormat } from "@/utils/dateFormatter";
import { formatDistance, formatPrice, getGuidFirst8 } from "@/utils/utils";
import useScreenDetector from "@/hooks/useScreenDetector";
import OriginToDestination from "@/pages/DealerDashboard/components/OriginToDestination/OriginToDesination";

const useAvailableShipmentsTableColumns = () => {
  const { isMobile } = useScreenDetector();

  return useMemo(
    () => [
      {
        title: "Shipment Id",
        dataIndex: "id",
        render: (text, record) => (
          <span className="span-click">
            {getGuidFirst8(text)}{" "}
            {record.isInternalShipment && (
              <Tag color="blue" style={{ display: "table" }}>
                Internal
              </Tag>
            )}
          </span>
        ),
      },
      {
        title: "Posted at",
        dataIndex: "postedAt",
        render: (text, record) => <span className="span-click">{dateStringToStandardFormat(record.postedAt)}</span>,
      },
      {
        title: "Pickup/DropOff Location",
        dataIndex: "pickupDropoffLocation",
        render: (_, record) => (
          <OriginToDestination
            record={{
              pickUpAddress: record.pickupAddress.simplifyAddress,
              dropOffAddress: record.dropOffAddress.simplifyAddress,
            }}
          />
        ),
      },
      {
        title: "Transporter Price",
        dataIndex: "totalTransporterPrice",
        render: text => <span className="span-click">{formatPrice(text)}</span>,
      },
      {
        title: "Price per Mile",
        dataIndex: "transporterPricePerMile",
        render: text => <span className="span-click">{formatPrice(text)}</span>,
      },
      {
        title: "Distance in Miles",
        dataIndex: "distance",
        render: text => <span className="span-click">{formatDistance(text)}</span>,
      },
      {
        title: "",
        dataIndex: "ribbon",
        render: (_, record) => {
          const exchangeId = record.childShipmentId ?? record.parentShipmentId;

          const exchangeStatus = record.childShipmentStatus ?? record.parentShipmentStatus;

          return exchangeId ? (
            <div
              style={{
                position: "absolute",
                top: "-0.0625rem",
                right: "-0.0625rem",
                padding: `${isMobile ? "0.125rem" : "0.25rem"} 0.625rem`,
                backgroundColor: "#2d6ac4",
                color: "#fff",
                fontSize: isMobile ? "0.625rem" : "0.75rem",
                borderTopRightRadius: "0.625rem",
                borderBottomLeftRadius: "0.25rem",
                whiteSpace: "nowrap",
              }}
              onClick={e => {
                e.stopPropagation();
                if (exchangeStatus === 2) {
                  window.location.href = `/loads/shipments/view?shipmentId=${exchangeId}`;
                }
              }}
            >
              {`Exchange With: ${getGuidFirst8(exchangeId)}`}
            </div>
          ) : null;
        },
      },
    ],
    [isMobile],
  );
};

export default useAvailableShipmentsTableColumns;
